module.exports = __webpack_public_path__ + "static/media/Conical-Spring_355x237.ae8b6724.jpg";